import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import React, { useState, useEffect } from 'react';
import Login from './Admin/pages/Login';
// import { BlogProvider } from './fetchdata/BlogContext';


import Dashboard from './Admin/pages/Dashboard';
import Addblog from './Admin/pages/Blogs/Addblog';
import AddGallery from './Admin/pages/Gallery/addGallery';
import BuildBlogs from './Admin/pages/builder/buildBlogs';
import AdminAllBlogs from './Admin/pages/Blogs/AllBlogs';
import EditAdminBlogs from './Admin/pages/Blogs/EditAdminBlogs';
import AllCategory from './Admin/pages/category/AllCategory';
import EditCategory from './Admin/pages/category/EditCategory';
import AddCategory from './Admin/pages/category/AddCategory';
import AllProduct from './Admin/pages/product/AllProduct';
import EditProduct from './Admin/pages/product/EditProduct';
import AddProduct from './Admin/pages/product/AddProduct';

import AddAttribute from './Admin/pages/attribute/AddAttribute';
import EditAttribute from './Admin/pages/attribute/EditAttribute';
import AllAttribute from './Admin/pages/attribute/AllAttribute';

import AddTag from './Admin/pages/tag/AddTag';
import EditTag from './Admin/pages/tag/EditTag';
import AllTag from './Admin/pages/tag/AllTag';

import MenuBuilder from './Admin/pages/builder/MenuBuilder';
import FooterMenuBuilder from './Admin/pages/builder/FooterMenuBuilder';

import HomeLayout from './Admin/pages/home/HomeLayout';
import AllReview from './Admin/pages/review/AllReview';
import AllOrder from './Admin/pages/order/AllOrder';
import PendingOrder from './Admin/pages/order/PendingOrder';
import CompleteOrder from './Admin/pages/order/CompleteOrder';

import AllUser from './Admin/pages/user/AllUser';
import AllClinic from './Admin/pages/user/AllClinic';
import AllDoctor from './Admin/pages/user/AllDoctor';
import UserView from './Admin/pages/user/UserView';
import ThemeSetting from './Admin/pages/home/ThemeSetting';

import AllZones from './Admin/pages/zones/AllZones';
import EditZones from './Admin/pages/zones/EditZones';
import AddZones from './Admin/pages/zones/AddZones';

import AllTax from './Admin/pages/tax/AllTax';
import EditTax from './Admin/pages/tax/EditTax';
import AddTax from './Admin/pages/tax/AddTax';

import AllPromo from './Admin/pages/promo/AllPromo';
import EditPromo from './Admin/pages/promo/EditPromo';
import AddPromo from './Admin/pages/promo/AddPromo';
import OrderView from './Admin/pages/order/OrderView';

import AddPage from './Admin/pages/pages/AddPage';
import AllPage from './Admin/pages/pages/AllPage';
import EditPage from './Admin/pages/pages/EditPage';
import AllImages from './Admin/pages/Gallery/AllImages';
import AllEnquire from './Admin/pages/enquire/AllEnquire';
import AllEnquireConsultation from './Admin/pages/enquire/AllEnquireConsultation';

import AddPlanCategory from './Admin/pages/planCategory/AddPlanCategory';
import AllPlanCategory from './Admin/pages/planCategory/AllPlanCategory';
import AddPlan from './Admin/pages/plan/AddPlan';
import AllPlan from './Admin/pages/plan/AllPlan';
import EditPlan from './Admin/pages/plan/EditPlan';
import ProfileEdit from './Admin/pages/user/ProfileEdit';

import Forgot from './Admin/pages/Forgot';

import Admin404 from './Admin/pages/Admin404';

import { Toaster } from "react-hot-toast";
import './Admin/assets/volt.css';  

import getCookie from './helpers/getCookie';
import getDecryptData from './helpers/getDecryptData';
import getUserData from "./helpers/userAuth";
import { ThemeProvider } from './fetchdata/ThemeContext';
import PlanView from './Admin/pages/plan/PlanView';
import AllEnquireHealth from './Admin/pages/enquire/AllEnquireHealth';
import BuyPlan from './Admin/pages/plan/BuyPlan';
import MyHealthCard from './Admin/pages/healthcard/MyHealthCard';
import AddDepartment from './Admin/pages/department/AddDepartment';
import AllDepartment from './Admin/pages/department/AllDepartment';
import EditDepartment from './Admin/pages/department/EditDepartment';
import AdminLoader from './Admin/pages/AdminLoader';
import AllTransactions from './Admin/pages/transaction/AllTransactions';
import AllHealthCard from './Admin/pages/healthcard/AllHealthCard';
import OrderCreate from './Admin/pages/order/OrderCreate';
import SignupUserType from './Admin/pages/user/SignupUserType';
import OrderEdit from './Admin/pages/order/OrderEdit';
import AllOrderRental from './Admin/pages/order/AllOrderRental';
import AllOrderDoctor from './Admin/pages/order/AllOrderDoctor';
import AllOrderNurse from './Admin/pages/order/AllOrderNurse';
import AllPendingOrder from './Admin/pages/order/AllPendingOrder';
import AllActiveOrder from './Admin/pages/order/AllActiveOrder';
import AllCompleteOrder from './Admin/pages/order/AllCompleteOrder';
import AllCancelOrder from './Admin/pages/order/AllCancelOrder';
import AllOverDueOrder from './Admin/pages/order/AllOverDueOrder';
import AllReport from './Admin/pages/report/AllReport';
import OrderRenew from './Admin/pages/order/OrderRenew';
import OrderFullView from './Admin/pages/order/OrderFullView';
import AddSkillDepartment from './Admin/pages/skillDepartment/AddSkillDepartment';
import AllSkillDepartment from './Admin/pages/skillDepartment/AllSkillDepartment';
import EditSkillDepartment from './Admin/pages/skillDepartment/EditSkillDepartment';
import AddAttributeDepartment from './Admin/pages/AttributeDepartment/AddAttributeDepartment';
import AllAttributeDepartment from './Admin/pages/AttributeDepartment/AllAttributeDepartment';
import EditAttributeDepartment from './Admin/pages/AttributeDepartment/EditAttributeDepartment';
import AddNurseDepartment from './Admin/pages/nurseDepartment/AddNurseDepartment';
import AllNurseDepartment from './Admin/pages/nurseDepartment/AllNurseDepartment';
import EditNurseDepartment from './Admin/pages/nurseDepartment/EditNurseDepartment';
import AllUserNurse from './Admin/pages/user/AllUserNurse';
import UserViewEdit from './Admin/pages/user/UserViewEdit';
import SignupUserNurse from './Admin/pages/user/SignupUserNurse';
import AllProductAdmin from './Admin/pages/product/AllProductAdmin';
import LeadCreate from './Admin/pages/order/LeadCreate';
import AllLeads from './Admin/pages/order/AllLeads';
import LeadEdit from './Admin/pages/order/LeadEdit';
import AllLeadProduct from './Admin/pages/LeadProduct/AllLeadProduct';
import AddLeadProduct from './Admin/pages/LeadProduct/AddLeadProduct';
import EditLeadProduct from './Admin/pages/LeadProduct/EditLeadProduct';
import AllCompleteLeads from './Admin/pages/order/AllCompleteLeads';
import LeadEditShort from './Admin/pages/order/LeadEditShort';
import VideoCall from './Admin/pages/video/VideoCall';
import FullCalender from './Admin/pages/calender/FullCalender';
import AllVideoCall from './Admin/pages/video/AllVideoCall';
import UserAllTransactions from './Admin/pages/wallet/UserAllTransactions';
import UserAllPayments from './Admin/pages/wallet/UserAllPayments';
import AllRedeem from './Admin/pages/redeem/AllRedeem';
import OrderCreateAppointment from './Admin/pages/order/OrderCreateAppointment';
import OrderQueeView from './Admin/pages/order/OrderQueeView';
import DoctorQueeView from './Admin/pages/order/DoctorQueeView';
import ThemeBuilder from './Admin/pages/home/ThemeBuilder';

const ScrollToTop = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return null;
};


function App() {

  const location = useLocation(); // Get the current location from React Router
  const isLoginFromLocalStorage = getCookie("token") ? true : false;
  const [isUserAuthenticated, setIsUserAuthenticated] = useState(
    isLoginFromLocalStorage
  );

  const [isUsertype, setisUsertype] = useState(null);
  const [isUserEmpType, setisUserEmpType] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setIsUserAuthenticated(isLoginFromLocalStorage);
      const mydata = await getDecryptData();
      if (mydata) {
        const mydatatype = mydata.type;
        const myempType = mydata.empType;
        setisUsertype(mydatatype);
        setisUserEmpType(myempType);
      }

      console.log("mydata", mydata, isLoginFromLocalStorage);

      window.scrollTo(0, 0);
      const timeoutId = setTimeout(() => {
        // const rootElement = document.getElementById("root");
        // if (rootElement.innerHTML === "") {
        //   navigate("/error", { replace: true });
        //   window.location.reload();
        //   setIsError(true);
        //   console.log("error found");
        // }
        // console.log(" found", rootElement);
      }, 1000); // Adjust the timeout duration as needed

      return () => clearTimeout(timeoutId);
    };

    fetchData();
  }, [isLoginFromLocalStorage, location.pathname]);

  return (

    <>
      <ThemeProvider>


        <Toaster />

        <Routes>


          <Route
            path="/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Navigate to="/dashboard" />) ||
                  (isUsertype === 0 && <Navigate to="/dashboard" />))) || <Login />
            }
          />


          <Route
            path="/forgot"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Forgot />) ||
                  (isUsertype === 0 && <Forgot />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/dashboard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <Dashboard />) ||
                  (isUsertype === 0 && <Dashboard />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/addblog"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <Addblog />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-gallery"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddGallery />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/buildBlogs/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <BuildBlogs />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/allblogs"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AdminAllBlogs />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/edit-blog/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditAdminBlogs />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllCategory />))) || <Navigate to="/" />
            }
          />



          <Route
            path="/edit-category/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-product"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddProduct />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-product"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllProduct />))) || <Navigate to="/" />
            }
          />

                    <Route
            path="/all-product-admin"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllProductAdmin />))) || <Navigate to="/" />
            }
          />



          <Route
            path="/edit-product/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditProduct />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-attribute"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddAttribute />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-attribute"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllAttribute />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-attribute/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditAttribute />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-tag"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddTag />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-tag"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllTag />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-tag/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditTag />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-menu"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <MenuBuilder />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-footer-menu"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <FooterMenuBuilder />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/home-layout"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <HomeLayout />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-enquire"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllEnquire />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-enquire-consultation"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllEnquireConsultation />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/all-user" 
               element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 &&  <AdminLoader />) ||
                   (isUsertype === 0 && <AllUser />))) || 
                  ((isUsertype === 1 && isUserEmpType === 2) && <AllUser /> )   || <AdminLoader />
            }

          />

          <Route
            path="/all-clinic"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 &&  <AdminLoader />) ||
                   (isUsertype === 0 && <AllClinic />))) || <Navigate to="/" />
            }

          />

          <Route
            path="/all-doctor"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 &&  <AdminLoader />) ||
                   (isUsertype === 0 && <AllDoctor />))) || 
                  ((isUsertype === 1 && isUserEmpType === 2) && <AllDoctor /> )   || <AdminLoader />
            }

          />
 

          <Route
            path="/all-user-nurse"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllUserNurse />))) || <Navigate to="/" />
            }
          />





          <Route
            path="/user/:slug"
           
             element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 &&  <AdminLoader />) ||
                   (isUsertype === 0 && <UserView />))) || 
                  ((isUsertype === 1 && isUserEmpType === 2) && <UserView /> )   || <AdminLoader />
            }

          />

          
          
          <Route
            path="/user-edit/:slug"

              element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 &&  <AdminLoader />) ||
                   (isUsertype === 0 && <UserViewEdit />))) || 
                  ((isUsertype === 1 && isUserEmpType === 2) && <UserViewEdit /> )   || <AdminLoader />
            }

           
          />
          

          <Route
            path="/theme-setting"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <ThemeSetting />))) || <Navigate to="/" />
            }
          />

            <Route
            path="/theme-builder"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <ThemeBuilder />))) || <Navigate to="/" />
            }
          />


          

          <Route
            path="/add-zones"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddZones />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-zones"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllZones />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-zones/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditZones />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-taxes"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditZones />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-taxes"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllTax />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-taxes/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditTax />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-promo"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPromo />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-promo"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPromo />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/edit-promo/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPromo />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-page"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPage />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-page"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPage />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-page/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPage />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-images"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllImages />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/add-plan-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPlanCategory />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-plan-category"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPlanCategory />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-plan"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddPlan />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-plan"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllPlan />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-plan/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPlan />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-plan/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditPlan />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/profile/edit"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <ProfileEdit />) ||
                  (isUsertype === 0 && <ProfileEdit />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-enquire-health"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                   (isUsertype === 1 && <AllEnquireHealth />) ||
                  (isUsertype === 0 && <Dashboard />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddDepartment />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllDepartment />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-department/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditDepartment />))) || <Navigate to="/" />
            }
          />


          <Route
            path="/add-skill-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddSkillDepartment />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-skill-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllSkillDepartment />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-skill-department/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditSkillDepartment />))) || <Navigate to="/" />
            }
          />


     <Route
            path="/add-nurse-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddNurseDepartment />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-nurse-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllNurseDepartment />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-nurse-department/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditNurseDepartment />))) || <Navigate to="/" />
            }
          />



     <Route
            path="/add-attribute-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AddAttributeDepartment />))) || <Navigate to="/" />
            }
          />
          <Route
            path="/all-attribute-department"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllAttributeDepartment />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-attribute-department/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <EditAttributeDepartment />))) || <Navigate to="/" />
            }
          />



          <Route
            path="/all-transactions"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllTransactions />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/all-healthcard"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllHealthCard />))) || <Navigate to="/" />
            }
          />

<Route
            path="/create-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <OrderCreate />) ||
                  (isUsertype === 0 && <OrderCreate />))) || <Navigate to="/" />
            }
          />


<Route
            path="/create-appointment"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <OrderCreateAppointment />) ||
                  (isUsertype === 0 && <OrderCreateAppointment />))) || <Navigate to="/" />
            }
          />

<Route   path="/create-lead"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <LeadCreate />) ||
                  (isUsertype === 0 && <LeadCreate />))) || <Navigate to="/" />
            }
          />
          


<Route
            path="/create-user"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 &&  <AdminLoader />) ||
                   (isUsertype === 0 && <SignupUserType />))) || 
                  ((isUsertype === 1 && isUserEmpType === 2) && <SignupUserType /> )   || <AdminLoader />
            }
          />

<Route
            path="/create-user/nurse"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <SignupUserNurse />))) || <Navigate to="/" />
            }
          />

<Route
            path="/wallet/all-transaction"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <UserAllTransactions />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          />

<Route
            path="/wallet/all-payment"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <UserAllPayments />) ||
                  (isUsertype === 0 && <AdminLoader />))) || <Navigate to="/" />
            }
          />

<Route
            path="/redeem/all-redeem"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllRedeem />) ||
                  (isUsertype === 0 && <AllRedeem />))) || <Navigate to="/" />
            }
          />

          

<Route
            path="/all-report"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AdminLoader />) ||
                  (isUsertype === 0 && <AllReport />))) || <Navigate to="/" />
            }
          />



<Route
            path="/all-order"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllOrder />) ||
                  (isUsertype === 0 && <AllOrder />))) || <Navigate to="/" />
            }
          />

<Route
            path="/all-lead"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllLeads />) ||
                  (isUsertype === 0 && <AllLeads />))) || <Navigate to="/" />
            }
          />

<Route
            path="/all-complete-lead"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllCompleteLeads />) ||
                  (isUsertype === 0 && <AllCompleteLeads />))) || <Navigate to="/" />
            }
          />




<Route
            path="/all-order-rental"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllOrderRental />) ||
                  (isUsertype === 0 && <AllOrderRental />))) || <Navigate to="/" />
            }
          />

<Route  path="/all-order-doctor"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllOrderDoctor />) ||
                  (isUsertype === 0 && <AllOrderDoctor />))) || <Navigate to="/" />
            } />


<Route  path="/all-order-nurse"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllOrderNurse />) ||
                  (isUsertype === 0 && <AllOrderNurse />))) || <Navigate to="/" />
            } />

<Route  path="/all-active-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllActiveOrder />) ||
                  (isUsertype === 0 && <AllActiveOrder />))) || <Navigate to="/" />
            } />

<Route  path="/all-completed-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllCompleteOrder />) ||
                  (isUsertype === 0 && <AllCompleteOrder />))) || <Navigate to="/" />
            } />

<Route  path="/all-cancel-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllCancelOrder />) ||
                  (isUsertype === 0 && <AllCancelOrder />))) || <Navigate to="/" />
            } />

<Route  path="/all-over-due-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllOverDueOrder />) ||
                  (isUsertype === 0 && <AllOverDueOrder />))) || <Navigate to="/" />
            } /> 

<Route
            path="/edit-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <OrderEdit />) ||
                  (isUsertype === 0 && <OrderEdit />))) || <Navigate to="/" />
            }
          />


<Route
            path="/quee/:hospital/"
            element={
             <OrderQueeView />
            }
          />
          

          <Route
            path="/doctor/:hospital/"
            element={
             <DoctorQueeView />
            }
          />


<Route
            path="/edit-lead/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <LeadEdit />) ||
                  (isUsertype === 0 && <LeadEdit />))) || <Navigate to="/" />
            }
          />

          <Route
            path="/edit-lead-short/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <LeadEditShort />) ||
                  (isUsertype === 0 && <LeadEditShort />))) || <Navigate to="/" />
            }
          />


          
<Route
            path="/edit-lead-product/:slug"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <EditLeadProduct />) ||
                  (isUsertype === 0 && <EditLeadProduct />))) || <Navigate to="/" />
            }
          />

<Route
            path="/add-lead-product"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AddLeadProduct />) ||
                  (isUsertype === 0 && <AddLeadProduct />))) || <Navigate to="/" />
            }
          />

<Route
            path="/all-lead-product"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <AllLeadProduct />) ||
                  (isUsertype === 0 && <AllLeadProduct />))) || <Navigate to="/" />
            }
          />
<Route
            path="/view-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <OrderFullView />) ||
                  (isUsertype === 0 && <OrderFullView />))) || <Navigate to="/" />
            }
          />

<Route
            path="/video-call/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <VideoCall />) ||
                  (isUsertype === 1 && <VideoCall />) ||
                  (isUsertype === 0 && <VideoCall />))) || <Navigate to="/" />
            }
          />

<Route
            path="/all-video-call/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AllVideoCall />) ||
                  (isUsertype === 1 && <AllVideoCall />) ||
                  (isUsertype === 0 && <AllVideoCall/>))) || <Navigate to="/" />
            }
          />



<Route
            path="/full-calender/"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <FullCalender />) ||
                  (isUsertype === 0 && <FullCalender />))) || <Navigate to="/" />
            }
          />

          



<Route
            path="/renew-order/:id"
            element={
              (isUserAuthenticated &&
                ((isUsertype !== 1 && isUsertype !== 0 && <AdminLoader />) ||
                  (isUsertype === 1 && <OrderRenew />) ||
                  (isUsertype === 0 && <OrderRenew />))) || <Navigate to="/" />
            }
          />




          <Route path="*" element={<Admin404 />} />

        </Routes>
        <ScrollToTop />
      </ThemeProvider>
    </>
  );
}

export default App;
